// extracted by mini-css-extract-plugin
module.exports = {"pseudolink":"U3kmj","theme_colored":"I4lw2","bold":"h976h"};